"use client";

import { c as _c } from "react/compiler-runtime";
import { FaArrowRight } from "react-icons/fa";
import { Button } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { cx } from "@/lib/tailwind-utils";
import { useServicesView } from "./use-services-view";
import { SelfScheduleStep } from "@/stores/self-schedule-store";
interface FloatingServiceCounterProps {
  /** Briefly emphasises the counter when a preselected service lands in it. */
  isHighlighted?: boolean;
}
export function FloatingServiceCounter(t0) {
  const $ = _c(25);
  const {
    isHighlighted: t1
  } = t0;
  const isHighlighted = t1 === undefined ? false : t1;
  const {
    selectedServices,
    setConfirmedServiceSelections,
    firstStep,
    isRwgLanding
  } = useSelfScheduleContext();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    effectiveNumAllowedServices
  } = useServicesView(t2);
  const hideOnSingleSelect = effectiveNumAllowedServices <= 1 && !isRwgLanding;
  if (hideOnSingleSelect) {
    return null;
  }
  const t3 = firstStep === SelfScheduleStep.SERVICE && "text-caption";
  const t4 = isHighlighted && "scale-110 shadow-xl ring-2 ring-primary";
  let t5;
  if ($[1] !== t3 || $[2] !== t4) {
    t5 = cx("fixed right-1/2 translate-x-1/2", "rounded-full bg-background/70 backdrop-blur-md", "flex items-center gap-2", "text-body", "font-medium", "border", "transition-all duration-300", "shadow-md", "z-20 bottom-[10%]", t3, t4);
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = selectedServices?.length && "pr-0";
  let t7;
  if ($[4] !== t6) {
    t7 = cx("p-2 pl-3 pr-0.5", "text-nowrap", t6);
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== effectiveNumAllowedServices || $[7] !== selectedServices?.length) {
    t8 = selectedServices?.length ? <><span className="hidden md:inline">Selected </span>{selectedServices?.length} of {effectiveNumAllowedServices}{" "}services{" "}</> : <span>Select up to {effectiveNumAllowedServices} services</span>;
    $[6] = effectiveNumAllowedServices;
    $[7] = selectedServices?.length;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = !selectedServices?.length && "!max-w-0 !px-0 opacity-0";
  let t11;
  if ($[12] !== t10) {
    t11 = cx("overflow-hidden text-nowrap rounded-e-full", "transition-all duration-500 ease-in-out", "group/continue-button max-w-40", "py-2", "hover:pr-6", t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== setConfirmedServiceSelections) {
    t12 = () => {
      setConfirmedServiceSelections(true);
    };
    $[14] = setConfirmedServiceSelections;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span>Continue</span>;
    t14 = <FaArrowRight className="ml-2 flex-shrink-0 transition-all duration-300 group-hover/continue-button:translate-x-2" />;
    $[16] = t13;
    $[17] = t14;
  } else {
    t13 = $[16];
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t11 || $[19] !== t12) {
    t15 = <Button variant="primary" className={t11} onClick={t12}>{t13}{t14}</Button>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t15 || $[22] !== t5 || $[23] !== t9) {
    t16 = <div data-self-schedule-service-counter="" className={t5}>{t9}{t15}</div>;
    $[21] = t15;
    $[22] = t5;
    $[23] = t9;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  return t16;
}